export default __webpack_public_path__ + "static/media/822-min.bbf2884a.png";